// eslint-disable-next-line import/prefer-default-export
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const START_TITLE_FLASHING = 'START_TITLE_FLASHING';
export const STOP_TITLE_FLASHING = 'STOP_TITLE_FLASHING';

export const showNotification = ({ title, body }) => ({
  payload: { title, body },
  type: SHOW_NOTIFICATION,
});
